(() => {
  const initialise = (root) => {
    const offer = root.querySelector('[data-kd-offer]');
    if (!offer) return;

    const endTime = Date.parse(offer.dataset.offerEnds || '');
    if (Number.isFinite(endTime) && Date.now() > endTime) {
      offer.hidden = true;
    }
  };

  const initialiseAll = (scope = document) => {
    scope.querySelectorAll('[data-kd-harbour-contact]').forEach(initialise);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll(), { once: true });
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
